
const digest = '206f0640255f30d0afe4a4d3070e4661bfb439d148298d1e5ee344d265c81e27';
const classes = {"item":"_item_tyzts_1","leftPart":"_leftPart_tyzts_15","controls":"_controls_tyzts_22","button":"_button_tyzts_28","title":"_title_tyzts_31","notSigned":"_notSigned_tyzts_36","note":"_note_tyzts_42"};
const css = `._item_tyzts_1 {
  display: flex;
  flex-direction: row;
  padding: 24px;
  border: 1px solid #eaedf3;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  gap: 10px;
  font-family: Rubik, "sans-serif";
}
._item_tyzts_1:nth-child(even) {
  background-color: #fbfbfd;
}
._item_tyzts_1 ._leftPart_tyzts_15 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-start;
  flex: 1;
}
._item_tyzts_1 ._controls_tyzts_22 {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
}
._item_tyzts_1 ._controls_tyzts_22 ._button_tyzts_28 {
  width: fit-content;
}
._item_tyzts_1 ._title_tyzts_31 {
  font-size: 14px;
  font-weight: 600;
  margin-top: 3px;
}
._item_tyzts_1 ._notSigned_tyzts_36 {
  color: #d81616;
  font-size: 14px;
  font-weight: 500;
  margin: 5px 0;
}
._item_tyzts_1 ._note_tyzts_42 {
  font-size: 12px;
  font-weight: 400;
  margin-top: 4px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  